import { ME } from './globals';


/**
 * Regular expression for the CDN string obtained from MeConfig.
 */
let CDN_REGEX: RegExp;

/**
 * Default value for the CDN Domain.
 */
let DOMAIN_RESULT: string | undefined | null = null;

/**
 * Get the url root host where MeControl javascript is being pulled from.
 */
export function getRootDomainUrl(): string {
    const config = ME.Config;
    if (DOMAIN_RESULT == null && ME.Config.cdnRegex != "") {
        CDN_REGEX = new RegExp(ME.Config.cdnRegex);
        DOMAIN_RESULT = checkIfCDNDomainExists(CDN_REGEX);
    }
    return DOMAIN_RESULT ? DOMAIN_RESULT : config.gfx;
}

/**
 * Iterates through each script file and compares it to the regex
 * @param scripts The array of scripts in the HTML document
 * @returns A CDN Domain
 */
export function checkIfCDNDomainExists(cdnRegex: RegExp): string | undefined {
    const scripts = document.getElementsByTagName('script');
    if (scripts) {
        const scriptsArray: HTMLScriptElement[] = Array.prototype.slice.call(scripts);
        for (let i = 0; i < scriptsArray.length; i++) {
            const result = cdnRegex.exec(scriptsArray[i].src);
            if (result) {
                return result[0];
            }
        }
    }
    return undefined;
}

/**
 * checks if the string is a valid URL
 * @param str The string to check
 */
export function isValidURL(str: string): boolean {
    try {
        new URL(str);
        return true;
    } catch (e) {
        return false;
    }
}